'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerDefaultComponentTheme = exports.defaultThemeBlueprintBroadcast = exports.extractThemeOrDefault = exports.composeReactackleTheme = exports.defaultTheme = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _lodash = require('lodash.mapvalues');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.pick');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.merge');

var _lodash6 = _interopRequireDefault(_lodash5);

var _misc = require('./utils/misc');

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _createBroadcast = require('./utils/create-broadcast');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var baseKeys = Object.keys(_base2.default);

var buildByBlueprint = function buildByBlueprint(blueprint, base) {
  var mixin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _lodash2.default)(blueprint, function (value, key) {
    if ((0, _react.isValidElement)(value)) return value;
    if ((0, _misc.isObject)(value)) return buildByBlueprint(value, base, mixin[key]);
    var current = (0, _misc.isUndef)(mixin[key]) ? value : mixin[key];
    if ((0, _misc.isFunction)(current)) return current(base);
    if (Array.isArray(current)) return current.map(function (item) {
      return buildByBlueprint(item, base);
    });
    return current;
  });
};

var defaultThemeBlueprint = _extends({}, _base2.default, {
  components: {}
});

var defaultTheme = exports.defaultTheme = {
  reactackle: _extends({}, _base2.default, {
    components: {}
  })
};

var composeReactackleTheme = exports.composeReactackleTheme = function composeReactackleTheme() {
  var mixin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (!mixin) return defaultTheme;
  var newBase = (0, _lodash6.default)({}, _base2.default, (0, _lodash4.default)(mixin, baseKeys));
  var components = (0, _misc.isObject)(mixin.components) ? (0, _lodash2.default)(defaultThemeBlueprint.components, function (defaultComponentThemeBlueprint, key) {
    return buildByBlueprint(defaultComponentThemeBlueprint, newBase, mixin.components[key] || {});
  }) : defaultTheme.reactackle.components;
  return {
    reactackle: _extends({}, newBase, {
      components: components
    })
  };
};

var extractThemeOrDefault = exports.extractThemeOrDefault = function extractThemeOrDefault(theme) {
  if (!theme) return defaultTheme;
  if (!theme.reactackle) return _extends({}, theme, defaultTheme);
  return theme;
};

var defaultThemeBlueprintBroadcast = exports.defaultThemeBlueprintBroadcast = (0, _createBroadcast.createBroadcast)(defaultThemeBlueprint);

var registerDefaultComponentTheme = exports.registerDefaultComponentTheme = function registerDefaultComponentTheme(key, defaultComponentThemeBlueprint) {
  if (!defaultTheme.reactackle.components[key]) {
    defaultThemeBlueprint.components[key] = defaultComponentThemeBlueprint;
    defaultTheme.reactackle.components[key] = buildByBlueprint(defaultComponentThemeBlueprint, _base2.default);
    defaultThemeBlueprintBroadcast.publish(defaultThemeBlueprint);
  }
};